<template>
  <div>
    <b-button class="bloc-note-btn" v-b-modal="modalId" :aria-label="LG('HP_blocnoteButtonLabel')" :title="LG('HP_blocnoteButtonLabel')">
      <div class="bloc-note-icon-wrapper shadow-sm">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M485.52 384H528a16 16 0 0 0 16-16v-42.46a32 32 0 0 0-9.37-22.63L303.2 71.47l-71.7 71.7 231.39 231.45a32 32 0 0 0 22.63 9.38zM208.9 120.57l71.7-71.8L238.8 7a24.1 24.1 0 0 0-33.9 0L167 44.87a24 24 0 0 0 0 33.8zM128 368a16 16 0 0 0 16 16h283l-48-48H144a16 16 0 0 0-16 16zm480-240H405l48 48h139v288H48V176h171.07l-10.2-10.2-22.6-22.6-15.2-15.2H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zM144 304h203l-48-48H144a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16z" /></svg>
      </div>
    </b-button>

    <b-modal :id="modalId" :title="LG('HP_blocnoteButtonLabel')" hide-footer>
      <template slot="modal-header">
        <h5 class="modal-title">{{ LG("HP_blocnoteButtonLabel") }}</h5>
        <b-button class="close" aria-label="fermer" v-on:click="hideModal">X</b-button>
      </template>
      <Blocnote :situationIndex="situationIndex" :noteId="noteId" />
    </b-modal>
  </div>
</template>

<script>
import Blocnote from "@/components/Blocnote.vue";

export default {
  name: "BlocNoteAndBtn",

  components: {
    Blocnote,
  },

  props: {
    situationIndex: { type: Number },
    noteId: { type: Number },
    modalId: {
      type: String,
      default: "modal-blocnote",
    },
  },

  methods: {
    hasProps() {
      return this.situationIndex != undefined && this.id != undefined;
    },
    hideModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
<style scoped>
/* Button */
.bloc-note-icon-wrapper {
  background-color: white;
  border-radius: 50%;
  position: relative;
  min-height: 20px;
  width: 100%;
  padding-top: 100%;
}

.bloc-note-btn {
  border: none;
  background-color: transparent;
  width: 65px;
  border-radius: 50%;
  padding: 0;
}

.bloc-note-btn:hover .bloc-note-icon-wrapper,
.bloc-note-btn:focus .bloc-note-icon-wrapper {
  background-color: #154f68;
}

.bloc-note-btn:hover path,
.bloc-note-btn:focus path {
  fill: white;
}

svg {
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -62%);
}
path {
  fill: #154f68;
}

/* Modal */
::v-deep .modal-dialog {
  max-width: 1200px;
  margin-top: 40px;
}
::v-deep .modal-header {
  border: none;
}
::v-deep .modal-header .close {
  opacity: 1;

  background-color: #3f5d12;
  border: 3px solid white;
  border-radius: 50%;
  color: white;
  width: 65px;
  height: 65px;

  font-weight: 500;
  font-size: 40px;
  padding: 2px;

  position: relative;
  top: -52px;
}

::v-deep .modal-header .close:hover,
::v-deep .modal-header .close:focus,
::v-deep .modal-header .close:active {
  opacity: 1;
  background-color: gray;
}
::v-deep .modal-title {
  font-size: 1.7rem;
  font-weight: 600;
  margin-left: auto;
}

::v-deep .modal-content {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  font-size: 17px;
  color: black;
  padding: 25px;
  min-height: 640px;
}

/* ::v-deep .modal-backdrop {
  opacity: 1;
  background-color: transparent;
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
} */

@media print {
  button,
  nav,
  br {
    display: none !important;
  }
  h5 {
    margin-right: auto;
  }

  ::v-deep .modal {
    position: relative !important;
  }
  ::v-deep .modal-dialog {
    max-width: 100%;
    width: 100%;
    height: 100%;
  }
  /* #modal-blocnote___BV_modal_outer_ {
    width: 100% !important;
  } */
  ::v-deep .modal-backdrop {
    background-color: white;
    opacity: 1;
  }
}
</style>
